import { z } from 'zod'

export const paramsSchema = z.object({
  name: z.string().min(1).max(100),
  phone: z.string().min(1).max(50),
  email: z.string().email().min(5).max(254),
})

export type paramsType = z.infer<typeof paramsSchema>
